import React, { useState } from "react";
import { KeyRound } from "lucide-react";
import AdminLayout from "./AdminLayout";
import api from "../../api";
import { useToast } from "../../hooks/use-toast";

const ChangePassword = () => {
  const { toast } = useToast();
  const [oldPass, setOldPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [confirm, setConfirm] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!oldPass || !newPass) {
      toast({ title: "Please fill all fields", variant: "destructive" });
      return;
    }
    if (newPass !== confirm) {
      toast({ title: "New passwords do not match", variant: "destructive" });
      return;
    }
    try {
      await api.changePassword(oldPass, newPass);
      toast({ title: "Password changed successfully" });
      setOldPass("");
      setNewPass("");
      setConfirm("");
    } catch (err) {
      toast({ title: "Current password is incorrect", variant: "destructive" });
    }
  };

  const field =
    "w-full border border-gray-300 rounded-md px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#4a7fb5]";

  return (
    <AdminLayout title="Change Password" showBack>
      <form
        onSubmit={submit}
        className="bg-white border-2 border-dashed border-[#c0873a] rounded-lg p-5 space-y-4 max-w-md"
      >
        <div className="flex items-center gap-2 text-[#1f2a37]">
          <KeyRound className="w-5 h-5" />
          <h2 className="text-lg font-bold">Change Admin Password</h2>
        </div>
        <div>
          <label className="block text-sm font-medium text-[#5b6b7b] mb-1">
            Current Password:
          </label>
          <input
            type="password"
            value={oldPass}
            onChange={(e) => setOldPass(e.target.value)}
            className={field}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-[#5b6b7b] mb-1">
            New Password:
          </label>
          <input
            type="password"
            value={newPass}
            onChange={(e) => setNewPass(e.target.value)}
            className={field}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-[#5b6b7b] mb-1">
            Confirm New Password:
          </label>
          <input
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            className={field}
          />
        </div>
        <button
          type="submit"
          className="bg-[#4a7fb5] hover:bg-[#3d6c9c] text-white font-medium px-8 py-2.5 rounded-md transition-colors"
        >
          Update Password
        </button>
      </form>
    </AdminLayout>
  );
};

export default ChangePassword;
